module.exports = __webpack_public_path__ + "img/undraw_ai_green.d28187b2.svg";